// extracted by mini-css-extract-plugin
export var wrapper = "cardArticle-module--wrapper--548a0";